import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

export const NavDropdown = props => {
  const { isOpen, toggle, id, 'data-cy': dataCy, direction, disable, imageSrc, icon, name, align, style, children } = props;

  const dropdownContent = (
    <>
      <DropdownToggle
        color="white"
        style={{
          fontWeight: '500',
          boxShadow: 'none',
        }}
        className="d-flex align-items-center"
        disabled={disable}
      >
        {imageSrc ? <img src={imageSrc} width="34px" height="32px" alt="" /> : icon ? <FontAwesomeIcon icon={icon} /> : null}
        <span>{name}</span>
      </DropdownToggle>
      <DropdownMenu right={!align} style={style}>
        {children}
      </DropdownMenu>
    </>
  );

  return toggle ? (
    <UncontrolledDropdown nav inNavbar id={id} data-cy={dataCy} direction={direction} isOpen={isOpen} toggle={toggle}>
      {dropdownContent}
    </UncontrolledDropdown>
  ) : (
    <UncontrolledDropdown nav inNavbar id={id} data-cy={dataCy} direction={direction}>
      {dropdownContent}
    </UncontrolledDropdown>
  );
};
